import { render, staticRenderFns } from "./aerialViewV2.vue?vue&type=template&id=a87847f6&scoped=true&"
import script from "./aerialViewV2.vue?vue&type=script&lang=js&"
export * from "./aerialViewV2.vue?vue&type=script&lang=js&"
import style0 from "./aerialViewV2.vue?vue&type=style&index=0&id=a87847f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87847f6",
  null
  
)

export default component.exports